'use client'

import React from 'react'
import Image from 'next/image'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { OnlineRatingsMock } from '@components/CustomerStory/CustomerStoryMock'
import styles from './Ratings.module.scss'

const Ratings = () => {
  const { ref: ref1, animationClassName: animationClassName1 } = useAnimateOnVisible<HTMLDivElement>({
    animationDelayMs: 120,
  })
  const { ref: ref2, animationClassName: animationClassName2 } = useAnimateOnVisible<HTMLDivElement>({
    animationDelayMs: 180,
  })
  const { ref: ref3, animationClassName: animationClassName3 } = useAnimateOnVisible<HTMLDivElement>({
    animationDelayMs: 240,
  })
  return (
    <div className={styles.ratingContainer}>
      <div className={styles.ratingTopRow}>
        <div ref={ref1} className={`${styles.ratingCard} ${animationClassName1}`}>
          <Image className={styles.logo} src={OnlineRatingsMock.appStore.logo} alt="logo" height={64} width={64} />
          <div className={styles.content}>
            <p className={styles.rating}>
              <span className={styles.ratingValue}>{OnlineRatingsMock.appStore.rating}</span> / 5
            </p>
            <p className={styles.ratingSubtitle}>{OnlineRatingsMock.appStore.subTitle}</p>
          </div>
        </div>
        <div ref={ref2} className={`${styles.ratingCard} ${animationClassName2}`}>
          <Image className={styles.logo} src={OnlineRatingsMock.playStore.logo} alt="logo" height={64} width={64} />
          <div className={styles.content}>
            <p className={styles.rating}>
              <span className={styles.ratingValue}>{OnlineRatingsMock.playStore.rating}</span> / 5
            </p>
            <p className={styles.ratingSubtitle}>{OnlineRatingsMock.playStore.subTitle}</p>
          </div>
        </div>
      </div>
      <div ref={ref3} className={`${styles.ratingCard} ${animationClassName3}`}>
        <Image className={styles.logo} src={OnlineRatingsMock.google.logo} alt="logo" height={64} width={64} />
        <div className={styles.content}>
          <p className={styles.rating}>
            <span className={styles.ratingValue}>{OnlineRatingsMock.google.rating}</span> / 5
          </p>
          <p className={styles.ratingSubtitle}>{OnlineRatingsMock.google.subTitle}</p>
        </div>
      </div>
    </div>
  )
}

export default Ratings
